import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { CSS_CLASSES } from "../../../../css-classes";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Logo = (props) => {
  const initAssetConfig = {
    width: 30,
    height: 30,
    alt: 'default alt',
    description: 'default description',
    image: '/assets/images/default-images/logo.svg',
    link: '/'
  };

  const [assets, setAssets] = useState(initAssetConfig);
  const { otherMedia } = useSelector((state) => ({
    otherMedia: state.othermediaInformationListR.data,
  }));
  const deviceType = localStorage.getItem('device_type');
  useEffect(() => {
    const logoData = otherMedia?.['logo']?.[0] || {};
    const updatedAssets = {
      ...initAssetConfig,
      width: logoData.width || initAssetConfig.width,
      height: logoData.height || initAssetConfig.height,
      description: logoData.description || initAssetConfig.description,
      alt: logoData.alternate || initAssetConfig.alt,
      image: logoData.path || initAssetConfig.image,
      link: logoData.link || initAssetConfig.link,
    };

    setAssets(updatedAssets);
  }, [otherMedia, deviceType]);
  return (
    <>
      {assets.link ? (
        <Link to={assets.link}>
          <div className="header-logo">
            <span>
              <img
                loading="lazy"
                className={`img-fluid ${CSS_CLASSES.logo}`}
                src={assets.image}
                alt={assets.alt}
                width={assets.width}
                height={assets.height}
              />
            </span>
          </div>
        </Link>
      ) : (
        <div>
          <span>
            <img
              loading="lazy"
              className={`img-fluid ${CSS_CLASSES.logo}`}
              src={assets.image}
              alt={assets.alt}
              width={assets.width}
              height={assets.height}
            />
          </span>
        </div>
      )}
    </>
  );
};

Logo.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Logo);
